import UtilNumber from "./UtilNumber";

export default class UtilMoney{

    static toBRL = (value = 0) => {

        return new Intl.NumberFormat('default', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(UtilNumber.clamp(value,-999999999,999999999));

    };

    static toR$BRL = (value = 0) =>{

        return `R$ ${this.toBRL(value)}`;

    }

    static toNumber = (value = 0) => {

        return UtilNumber.toNumber(value);

    };

}